import moment, { Moment } from "moment-timezone";

export default class MetodoDePagamento implements IMetodoDePagamento {
  public id!: string;
  public idClienteStripe!: string;
  public dataCriacao!: Moment;
  public bandeira!: string;
  public ultimos4Numeros!: string;
  public dataValidade!: Moment;
  constructor(param: IMetodoDePagamento) {
    Object.assign(this, param);
  }
  public static fromJson(json: IMetodoDePagamentoJson): MetodoDePagamento {
    return new MetodoDePagamento({
      ...json,
      dataCriacao: moment.tz(json.dataCriacao, "America/Sao_Paulo"),
      dataValidade: moment.tz(json.dataValidade, "America/Sao_Paulo"),
    });
  }
}

interface IMetodoDePagamento {
  id: string;
  idClienteStripe: string;
  dataCriacao: Moment;
  bandeira: string;
  ultimos4Numeros: string;
  dataValidade: Moment;
}

export interface IMetodoDePagamentoJson
  extends Omit<IMetodoDePagamento, "dataCriacao" | "dataValidade"> {
  dataCriacao: string;
  dataValidade: string;
}
